import * as React from 'react';
import { useAnalytics } from 'src/providers';
import { AnalyticsAction, AnalyticsEvents } from 'src/types/Events';

export function useTrackOnce() {
  const { track } = useAnalytics();
  const [tracked, setTracked] = React.useState(false);

  return <T extends AnalyticsAction>(action: T, details: AnalyticsEvents[T]) => {
    if (!tracked) {
      track(action, details);
      setTracked(true);
    }
  };
}
